export default __webpack_public_path__ + "static/media/info_cashout.min.b7a7f6a1.png";